// extracted by mini-css-extract-plugin
module.exports = {"background":"style__background__XC7Nv"};